import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import DebtManagementDebtsWorkflow from '../DebtManagementDebtsWorkflow/AccountsWorkflowContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';
import TargetAmount from './Steps/TargetAmountContainer';
import TargetDate from './Steps/TargetDateContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

const EmergencyFundWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  isMobile,
  goToSummaryWhenReady,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Emergency Fund');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      goToSummaryWhenReady={goToSummaryWhenReady}
      workflowId={workflowId}
      analyticsWorkflowStarted="emergency_fund_workflow_started"
      outputFunction={outputFunction(clientId)}
      steps={[
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        DebtManagementDebtsWorkflow,
        TargetAmount,
        TargetDate,
        AccountsWorkflow,
      ]}
    />
  );
};

EmergencyFundWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default EmergencyFundWorkflowView;
